import { render } from "./Warehouses.vue?vue&type=template&id=a2af1d9c&scoped=true"
import script from "./Warehouses.vue?vue&type=script&lang=js"
export * from "./Warehouses.vue?vue&type=script&lang=js"

import "./Warehouses.vue?vue&type=style&index=0&id=a2af1d9c&lang=scss&scoped=true"

import exportComponent from "D:\\nawarat-libya\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2af1d9c"]])

export default __exports__